import React, { ReactElement } from 'react';
import { Config } from './types';

const HtmlWidget: React.FC<WidgetRenderProps<Config>> = (
  props: WidgetRenderProps<Config>
): ReactElement => {
  const {
    inputUrl,
    htmlValue,
    cssValue,
    jsValue,
    borderData,
    paddingData,
    lineColor,
    height,
    width,
    visible,
    isCustomWidget,
    urlPreview,
  } = props.widgetState.config;

  const iframeRef = React.useRef<HTMLIFrameElement>(null);

  React.useEffect(() => {
    const iframeDocument = iframeRef.current?.contentDocument;
    const iframeWindow = iframeRef.current?.contentWindow;
    if (iframeDocument && iframeWindow) {
      if (inputUrl === '') {
        iframeDocument.open();
        iframeDocument.write(`
        <!DOCTYPE html>
        <html>
          <head>
            <style>${cssValue}</style>
          </head>
          <body>${htmlValue}</body>
          <script>${jsValue}</script>
        </html>
      `);
        iframeDocument.close();
      } else {
        iframeDocument.open();
        iframeDocument.write(`
          <!DOCTYPE html>
          <html>
          <body> 
            <iframe width='${width}' height='${height}' src='${urlPreview}' scrolling:"no" style="border: none;"></iframe>
          </body>
          </html>
      `);
        iframeDocument.close();
      }
    }
  }, [htmlValue, cssValue, jsValue, urlPreview, height, width]);

  if (visible === false || isCustomWidget) {
    return <></>;
  }

  return (
    <>
      <iframe
        data-test-id="html-iframe-widget"
        style={{
          paddingTop: `${paddingData?.top}px`,
          paddingRight: `${paddingData?.right}px`,
          paddingBottom: `${paddingData?.bottom}px`,
          paddingLeft: `${paddingData?.left}px`,
          width: '100%',
          height: '100%',
          pointerEvents: `${
            window.location.pathname.includes('/apps/horizon-beta')
              ? window.location.pathname.includes('/preview')
                ? 'all'
                : 'none'
              : 'all'
          }`,
          borderWidth: `${borderData?.thickness}px`,
          borderTop: `${
            borderData?.isTopBorderVisible ?? true
              ? `${borderData?.thickness}px solid`
              : 'none'
          }`,
          borderBottom: `${
            borderData?.isBottomBorderVisible ?? true
              ? `${borderData?.thickness}px solid`
              : 'none'
          }`,
          borderLeft: `${
            borderData?.isLeftBorderVisible ?? true
              ? `${borderData?.thickness}px solid`
              : 'none'
          }`,
          borderRight: `${
            borderData?.isRightBorderVisible ?? true
              ? `${borderData?.thickness}px solid`
              : 'none'
          }`,
          borderRadius: `${borderData?.radius}px`,
          borderColor: `${lineColor}`,
          overflow: 'hidden',
        }}
        ref={iframeRef}
        scrolling="no"
      />
    </>
  );
};
export default HtmlWidget;
